module.exports = __webpack_public_path__ + "img/abstract.4e480955.png";